<template>
  <div class="component">
    <b-container fluid class="pl-25 pt-17 pb-25">
      <nav aria-label="breadcrumb" class="participant-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <b-link :to="{ name: `${isTestPortal ? TEST_PORTAL_SUFFIX_CONST : ''}research-site-details` }">Research Sites</b-link>
          </li>
          <li class="breadcrumb-item current-label">
            <span>Documents</span>
          </li>
        </ol>
      </nav>
      <addViewSiteDocument :siteId="siteId" :isAdmin="isAdmin" returnTo="add-research-site-documents"></addViewSiteDocument>
    </b-container>
  </div>
</template>
<script>
import { SYSTEM_ADMIN, STUDY_ADMIN, PI } from "@/constants/authRoles";
import addViewSiteDocument from "@/components/common/add-view-site-document";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import { TEST_PORTAL_SUFFIX } from "@/constants/config";

export default {
  name: "study-participant-documents",
  components: {
    addViewSiteDocument
  },
  data() {
    return {
      studyId: this.$route.params.studyId,
      siteId: this.$route.params.siteId,
      isAdmin: true,
      TEST_PORTAL_SUFFIX_CONST: TEST_PORTAL_SUFFIX
    };
  },
  computed: {
    ...mapGetters(["token", "user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    isTestPortal() {
      return (this.$route.name || this.$route.currentRoute.name || "").includes(TEST_PORTAL_SUFFIX);
    }
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
.participant-breadcrumb {
  width: auto;
  background-color: transparent;
}
.breadcrumb {
  padding: 0;
  background-color: transparent;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  list-style: none;
  border-radius: 0.25rem;
}
.breadcrumb-item {
  color: #4a4a4a;
  a {
    color: #4c8ce4;
  }
  &.current-label {
    color: #9b9b9b;
    cursor: text;
  }
}
</style>
